import {
  Bell,
  ClipboardList,
  Home,
  Languages,
  LogOut,
  Stethoscope,
  User,
} from 'lucide-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  type ButtonSidebarItem,
  CalendarIcon,
  type LinkSidebarItem,
} from '@virtual-care/ui';

import { useLanguage } from '../../i18n/use-language.ts';
import { logout } from '../firebase';

export function useSidebarData() {
  const { t } = useTranslation();
  const { toggle, language } = useLanguage();

  return useMemo(() => {
    const mainSidebarItems: LinkSidebarItem[] = [
      { href: '/', label: t('shell.sidebar.home'), icon: <Home /> },
      {
        href: '/appointments',
        label: t('shell.sidebar.appointments'),
        icon: <CalendarIcon />,
      },
      {
        href: '/specialties',
        label: t('shell.sidebar.doctors'),
        icon: <Stethoscope />,
      },
      {
        href: '/results',
        label: t('shell.sidebar.labResults'),
        icon: <ClipboardList />,
      },
      {
        href: '/profile',
        label: t('shell.sidebar.profile'),
        icon: <User />,
      },
    ];

    const footerSidebarItems: (LinkSidebarItem | ButtonSidebarItem)[] = [
      {
        label: `${t('shell.language.aria')} (${language.toUpperCase()})`,
        icon: <Languages />,
        onClick: () => {
          void toggle();
        },
      },
      {
        href: '/notifications',
        label: t('shell.sidebar.notifications'),
        icon: <Bell />,
      },
      {
        label: t('shell.sidebar.logout'),
        icon: <LogOut />,
        onClick: () => {
          logout().then(() => {
            window.location.href = '/';
          });
        },
      },
    ];

    return { mainSidebarItems, footerSidebarItems };
  }, [language, t, toggle]);
}
